;(function(){

	var $bn = $('#brew-news');

	if( $bn.length <= 0 ) return false;

	$bn = {
		root: $bn,
		wrapper: $bn.find('#brew-news__wrapper'),
		inner: $bn.find('#brew-news__inner'),
		articles: $bn.find('article.brew-news__article'),
		arrows: $bn.find('#brew-news__arrows'),
		current: false
	};

	var bn = {
		mobile: undefined,
		current: $bn.articles.filter('.brew-news__article--active').index(),
		busy: false,
		total: $bn.articles.length,
		x: 0,
		init: function(){

			// Store the articles
			$bn.articles
				.each(function(i){

					var $a = $(this);

					$bn.articles[i] = {
						root: $a,
						image: $a.find('.brew-news__article-image'),
						text: $a.find('.brew-news__article-text')
					};

				});

			// Get the current
			$bn.current = $bn.articles[bn.current];

			// Activate the arrows
			$bn.arrows
				.on('click', 'span', function(e){

					var next = $(this).is('.next'),
						newA = next ? bn.current + 1 : bn.current - 1;

					if( newA < 0 ){
						newA = bn.total - 1;
					}else if( newA > bn.total - 1 ){
						newA = 0;
					}

					bn.goTo(newA, next ? 'left' : 'right');

					e.preventDefault();

				});

			// Resize event
			site.resize.after['brewNews'] = bn.layout;
			bn.layout();

		},
		layout: function(){

			var mobile = site.width < 880;

			// Tidy up
			if( mobile !== bn.mobile ){

				TweenLite
					.set([
						$bn.wrapper,
						$bn.wrapper.children(),
						$bn.wrapper.find('.brew-news__article-text'),
						$bn.wrapper.find('.brew-news__article-text').children(),
						$bn.wrapper.find('.brew-news__article-image')
					],{
						clearProps: 'all'
					});

				bn.current = $bn.root.find('.brew-news__article--active').index();

				bn.mobile = mobile;

				$bn.wrapper[ mobile ? 'on' : 'off']('touchstart mousedown', bn.touchHandler);

			};

		},
		goTo: function(num, dir) {

			// Ignore if already active
			if( num == bn.current || bn.busy ) return;

			// Busy now
			bn.busy = true;

			// Find the new article
			var $new = $bn.articles[num],
				$old = $bn.current;

			// Hide the old image
			TweenLite
				.to($old.image, .3, {
					opacity: 0,
					scale: 1.05,
					ease: Cubic.easeIn,
					force3D: true
				});

			// Show the new article
			TweenLite
				.set($new.root, {
					visibility: 'visible',
					zIndex: 2
				});

			TweenLite
				.fromTo($bn.wrapper, .3, {
					height: $bn.wrapper.height()
				},{
					height: $new.root.innerHeight(),
					ease: Cubic.easeInOut,
					force3D: true,
					delay: .3,
					clearProps: 'all',
					onComplete: function(){

						TweenLite
							.set($new.root, {
								position: 'relative',
								clearProps: 'zIndex'
							});

					}
				});

			// Animate the new image
			TweenLite
				.fromTo($new.image, .6, {
					scale: .9,
					opacity: 0
				},{
					scale: 1,
					opacity: 1,
					ease: Elastic.easeOut.config(1, .75),
					delay: .3,
					force3D: true
				});

			// Hide the old text
			TweenLite
				.to($old.text, .3, {
					opacity: 0,
					ease: Back.easeIn,
					force3D: true,
					delay: .05,
					clearProps: 'all',
					onComplete: function(){

						TweenLite
							.set($old.root, {
								visibility: 'hidden',
								position: 'absolute'
							});

						// Not busy
						bn.busy = false;

					}
				});

			// Show the new text
			var x = dir ? dir == 'left' ? 30 : -30 : 0;

			TweenLite
				.fromTo($new.text, .3, {
					opacity: 0
				},{
					opacity: 1,
					delay: .05
				});

			$new.text
				.find('span, h1, p, a.cta')
				.each(function(i){

					TweenLite
						.fromTo(this, .6 + ( .02 * i ), {
							x: x,
							y: dir ? 0 : 30,
							opacity: 0
						},{
							x: 0,
							y: 0,
							opacity: 1,
							force3D: true,
							delay: .35 + ( i * .05 ),
							clearProps: 'all',
							ease: Expo.easeOut
						});

				});

			// Update stored variables
			$bn.current = $new;
			bn.current = num;

		},
		touchHandler: function(e){

			var mouse = e.type == 'mousedown';

			var width = $bn.inner.width(),
				touch = Modernizr.touchevents ? e.originalEvent.changedTouches[0] : false,
				startX = e.pageX || touch.pageX,
				startY = e.pageY || touch.pageY,
				endX = 0,
				active = false,
				vertical = false;

			if( bn.busy ) return false;

			$core.win
				.on('mousemove.bn touchmove.bn', function(e){

					var thisTouch = Modernizr.touchevents ? e.originalEvent.changedTouches[0] : false,
						x = e.pageX || thisTouch.pageX,
						y = e.pageY || thisTouch.pageY;

					if( active ){

						TweenLite
							.set($bn.wrapper, {
								x: x - startX
							});

						e.preventDefault();

					}else{

						if( Math.abs( y - startY ) > 4 && !active && !vertical ){

							vertical = true;

						}else if( Math.abs( x - startX ) > 4 && !active && !vertical ){

							active = true;
							vertical = false;

							$core.win
								.one('mouseup touchend', function(e){

									var x = e.pageX || e.originalEvent.changedTouches[0].pageX,
										distance = x - startX,
										next = distance < 0,
										newC = next ? bn.current + 1 : bn.current - 1;

									if( newC > bn.total - 1 || newC < 0 )
										newC = false;

									if( Math.abs( distance ) > site.width / 6 && newC !== false ){

										bn.busy = true;

										TweenLite
											.to($bn.wrapper, .2, {
												x: next ? 0 - width : width,
												ease: Cubic.easeOut,
												onComplete: function(){

													TweenLite
														.set($bn.wrapper, {
															x: 0,
															left: 0 - ( width * newC )
														});

													bn.current = newC;
													bn.busy = false;

												}
											});

									}else{

										TweenLite
											.to($bn.wrapper, .3, {
												x: 0,
												ease: Expo.easeOut
											});

									}

									$core.win.off('.bn');

								});

						}

					}

				});

		}
	};

	bn.init();

}());